/**
 * Màn hình danh sách người dùng
 */
import { memo } from "react";
import { Layout, Typography } from "antd";
import { Space } from "antd";
import _ from "lodash";
import ListGrowthStandardTemp from "pages/GrowthStandardTemp/ListGrowthStandardTemp";
const { Title } = Typography;
const { Content } = Layout;
function GrowthStandardTemp() {
  return (
    <Content
      className="custom-layout-content background-content-layout"
      style={{
        marginLeft: 24,
        marginTop: 16,
        marginRight: 24,
        // backgroundColor: "white",
      }}
    >
      <Space
        direction="vertical"
        style={{
          width: "100%",
        }}
        size={"large"}
      >
        <div className="space-between ">
          <Title style={{ marginBottom: 0 }} level={4}>
            Quản trị trọng lượng trung bình
          </Title>
        </div>
        <ListGrowthStandardTemp />
      </Space>
    </Content>
  );
}

export default memo(GrowthStandardTemp);
